// extracted by mini-css-extract-plugin
module.exports = {"listingCard":"listing-card_listingCard__ecsuV","listingCard__withoutBorder":"listing-card_listingCard__withoutBorder__NXsBJ"};